export default "__VITE_ASSET__Cu9UfwvZ__"